import React from 'react';
import { Box, AppBar, Toolbar, Typography } from '@mui/material';

interface AdminLayoutProps {
  children: React.ReactNode;
}

const AdminLayout: React.FC<AdminLayoutProps> = ({ children }) => {

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <AppBar position="sticky" elevation={0} sx={{ 
        bgcolor: 'background.paper',
        borderBottom: '1px solid',
        borderColor: 'divider'
      }}>
        <Toolbar>
          <Box component="img" src={`${process.env.PUBLIC_URL}/logo_with_bottom_text.svg`} alt="A3Tech Education" sx={{ height: 56, width: 84, objectFit: 'contain', mr: 1 }} />
          <Typography variant="h6" color="text.primary">
            A3 Tech Admin
          </Typography>
        </Toolbar>
      </AppBar>
      <Box component="main" sx={{ flexGrow: 1 }}>
        {children}
      </Box>
    </Box>
  );
};

export default AdminLayout;